import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'components';

const FilterBar = ({ onUpdate, defaultValue = {}, placeholder = 'Search' }) => (
  <Form onChange={onUpdate} className="form--search">
    <div className="form__row form--inline">
      <Form.Input
        name="search"
        placeholder={placeholder}
        className="input--search"
        defaultValue={defaultValue.search}
      />
    </div>
  </Form>
);

FilterBar.propTypes = {
  onUpdate: PropTypes.func,
  statuses: PropTypes.object,
  defaultValues: PropTypes.object,
  placeholder: PropTypes.string
};

export default FilterBar;
